import axios from '../../../utils/AxiosUtils';
import {
    DELETE_LOYALTY,
    DELETE_LOYALTY_IMAGE,
    GET_LOYALTY,
    IS_LOYALTY_NOT_FOUND,
    LOADING,
    SAVE_LOYALTY_SUCCESS,
    UPDATE_PROMOTION_IMAGE_SUCCESS
} from "../../types";
import MessageUtils from "../../../utils/MessageUtils";
import i18n from "../../../i18next";
import moment from "moment";

export const getLoyalty = (restaurantId) => async (dispatch) => {
    try {
        dispatch({type: LOADING, payload: true});
        const url = `/restaurant/${restaurantId}/loyalty`;
    
        const response = await axios().get(url);
    
        dispatch({
            type: GET_LOYALTY,
            payload: response.data
        });
        dispatch({type: IS_LOYALTY_NOT_FOUND, payload: false});
        dispatch({type: LOADING, payload: false});
    } catch (e) {
        if (e.response.data.code === 401) {
            dispatch({type: IS_LOYALTY_NOT_FOUND, payload: true});
        }
        console.error(e);
    }
};


export const saveLoyalty = (restaurantId, loyaltyForm, callback) => {
    return (dispatch, getState) => {

        dispatch({type: LOADING, payload: true});

        let imageFormData = loyaltyForm.formData;
        delete loyaltyForm.imagePreview;
        delete loyaltyForm.formData;

        if (moment(loyaltyForm.validity.startDate, 'DD-MM-YYYY').isAfter(moment(loyaltyForm.validity.endDate, 'DD-MM-YYYY'))) {
            MessageUtils.errorMessageResponse(dispatch, undefined, i18n.t('actions:loyaltyActions.validityDateOrderIncorrect'));
        } else if((loyaltyForm.orderTypes).length === 0){
            MessageUtils.errorMessageResponse(dispatch, undefined, i18n.t('actions:loyaltyActions.missingOrderTypes'));
        } else {
            if (loyaltyForm.id !== -1) {
                let url = `/promotion/${loyaltyForm.id}`;
                axios().put(url, loyaltyForm)
                    .then(response => saveLoyaltySuccess(dispatch, response, callback, getState, imageFormData, true))
                    .catch(error => {
                        MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:loyaltyActions.saveFail'));
                        callback();
                    });
            } else {
                let url = `/restaurant/${restaurantId}/promotion`;
                axios().post(url, loyaltyForm)
                    .then(response => saveLoyaltySuccess(dispatch, response, callback, getState, imageFormData, false))
                    .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:loyaltyActions.saveFail')));
            }
        }
    }
};

const saveLoyaltySuccess = (dispatch, response, callback, getState, formData, isUpdate) => {
    dispatch({type: LOADING, payload: false});
    dispatch({type: SAVE_LOYALTY_SUCCESS, payload: response.data});


    if (!formData) {
        if (isUpdate) {
            MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:loyaltyActions.updateSuccess'));
        } else {
            MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:loyaltyActions.saveSuccess'));
        }
    }

    const promotionId = response.data.id;
    if (formData !== undefined && formData !== null) {
        doUploadLoyaltyImage(promotionId, formData, dispatch, getState, isUpdate);
        callback();
    } else {
        callback();
    }
};

const doUploadLoyaltyImage = (promotionId, formData, dispatch, getState, updateMsg) => {

    dispatch({type: LOADING, payload: true});
    const newFormData = new FormData();
    newFormData.append('file', formData);

    const url = `/promotion/${promotionId}/upload-image`;
    const header = {headers: { 'Content-Type': 'multipart/form-data' }}

    axios().put(url, newFormData, header)
        .then(response => uploadLoyaltyImageSuccess(dispatch, response, updateMsg))
        .catch(error => MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:loyaltyActions.uploadImageFailure')));
};

const uploadLoyaltyImageSuccess = (dispatch, response, updateMsg) => {
    dispatch({type: LOADING, payload: false});
    dispatch({type: UPDATE_PROMOTION_IMAGE_SUCCESS, payload: response.data});
    if (updateMsg) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:loyaltyActions.updateSuccess'));
    } else {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:loyaltyActions.saveSuccess'));
    }
};

export const deleteLoyalty = (promotionId) => {
    return (dispatch) => {
        dispatch({type: LOADING, payload: true});
        const url = `/promotion/${promotionId}`;

        axios().delete(url)
            .then(response => {
                dispatch({type: LOADING, payload: false});
                dispatch({type: DELETE_LOYALTY, payload: response.data});
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:loyaltyActions.deleteSuccess'));
            })
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:loyaltyActions.deleteFail')));
    }
};

export const deleteLoyaltyImage = (promotionId) => {
    return (dispatch) => {
        dispatch({type: LOADING, payload: true});
        const url = `/promotion/${promotionId}/delete-image`;

        axios().put(url, {})
            .then(response => {
                dispatch({type: LOADING, payload: false});
                dispatch({type: DELETE_LOYALTY_IMAGE, payload: false});
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:loyaltyActions.deleteImageSuccess'));
            })
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:loyaltyActions.deleteImageFail')));
    }
};


// WEBPACK FOOTER //
// ./src/actions/restaurants/loyalty/LoyaltyActions.js